module.exports = __webpack_public_path__ + "static/media/flaucar.98bf0434.png";